import { useCallback, useState } from "react";
import { AgGrid } from "@jsq/ds/core";

export function useAgGridUtils<RowType = any>() {
  const [gridApi, setGridApi] = useState<AgGrid.GridApi<RowType> | null>(null);
  const [isFilterPresent, setIsFilterPresent] = useState(false);

  const onGridReady = (event: AgGrid.GridReadyEvent<RowType>) => {
    setGridApi(event.api);
  };

  const onFilterChanged = useCallback((event: AgGrid.FilterChangedEvent) => {
    setIsFilterPresent(event.api.isAnyFilterPresent());
  }, []);

  const resetFilters = useCallback(() => {
    if (!gridApi) return;
    gridApi.setFilterModel(null);
    gridApi.onFilterChanged();
  }, [gridApi]);

  const onGridSizeChanged = useCallback((event: AgGrid.GridSizeChangedEvent<RowType>) => {
    if (!event.api) return;
    event.api.sizeColumnsToFit();
  }, []);

  return {
    gridApi,
    onGridReady,
    resetFilters,
    isFilterPresent,
    onFilterChanged,
    onGridSizeChanged,
  };
}
